import { logTrackingEvent } from '@/utils/tracking';

import type { TrackingEventObject } from '@/types/tracking';

type HandleClickArgs = {
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>;
  eventText?: string;
  eventUrl?: string;
  tracking?: TrackingEventObject;
  onClick?: React.MouseEventHandler;
};

export const handleClick = ({ event, eventText, eventUrl = '', tracking, onClick }: HandleClickArgs) => {
  if (tracking) {
    const hasClickUrl = tracking.click_url || eventUrl;
    logTrackingEvent({
      ...tracking,
      ...(hasClickUrl && { click_url: tracking.click_url ?? eventUrl }),
    });
  } else if (eventText) {
    logTrackingEvent({
      event: 'interaction_click',
      component_name: 'button',
      click_text: eventText,
      click_url: eventUrl,
    });
  }

  onClick?.(event);
};
